/*
 * РАБОЧАЯ ОБЛАСТЬ ОБЯЗАНА ВЫЖИТЬ (ТЗ §7.3, последняя строка проверочного списка).
 *
 * Три полосы разом съедают 90 px, а вместе с полосой часового пояса — 120. На 768 это
 * ещё не беда: 768 − 46 (шапка) − 38 (панель журнала) − 90 = 594 px, и день при шаге 30
 * (624 px сетки) помещается почти целиком. Но высота окна бывает и 500 — браузер
 * с открытой консолью, половина экрана, старый нетбук, — и там четыре полосы, растущие
 * свободно, отняли бы у журнала всё.
 *
 * Поэтому у ленты полос есть ПОТОЛОК. Он не декоративный: переполнение прокручивается
 * внутри самой ленты, и рабочая область не может стать нулевой ни при какой высоте окна.
 * На поддерживаемых высотах прокрутка не появляется вовсе — потолок работает как пол
 * под рабочей областью, а не как ещё один способ спрятать текст.
 */
.stripes {
  flex: 0 1 auto;
  min-height: 0;
  max-height: 30vh;
  overflow-y: auto;
}

/*
 * На телефоне полос тот же максимум, но считается он от другого: экран выше, а полосы
 * там переносят текст и занимают по три строки. 40 % высоты — граница, за которой
 * «Мой день» перестаёт отвечать на вопрос «кто следующий» без прокрутки.
 */
@media (width <= 767px) {
  .stripes {
    max-height: 40vh;
  }
}
